<template>
<div >
<!-- :mask-closable="false"  禁止点击阴影关闭-->
      <p slot="header" style="text-align:center">
            <Icon type="person-add"></Icon>
            <span>{{languages.xiugaimima}}</span>
      </p>
      <div style="text-align:center">
          <!-- 表单主体 -->
           <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
               <!-- <FormItem label="账号名称"> -->
                  <!-- <div style="text-align:left;">{{userName | delQuotes}}</div> -->
              <!-- </FormItem> -->

              <FormItem :label=languages.yuanmima prop="password">
                  <Input type="password" v-model="formCustom.password"/>
              </FormItem>
              <FormItem :label=languages.xinmima prop="newPassword">
                  <Input type="password" v-model="formCustom.newPassword"/>
              </FormItem>
              <FormItem :label=languages.querenmima prop="passwordCheck">
                  <Input type="password" v-model="formCustom.passwordCheck" number/>
              </FormItem>
          </Form>
      </div>
      <div slot="footer" style="text-align:center">
          <Button type="primary" @click="handleSubmit('formCustom')">{{languages.queding}}</Button>
      </div>

</div>

</template>
<style>

</style>
<script>
  import api from '../api/apinew'
  import config from 'config/apiConfig';
  import axios from 'axios'
  import Qs from 'qs'
  import language from 'api/language.js'

  export default{
    data(){
          const validateOldPass = (rule, value, callback) => {
              if (value === '') {
                  callback(new Error(language.yuanmima));
              } else {
                callback();
              }
          };
          const validatePass = (rule, value, callback) => {
              if (value === '') {
                  callback(new Error(language.xinmimabunengweikong));
              } else {
                  if (this.formCustom.passwordCheck !== '') {
                      // 对第二个密码框单独验证
                      this.$refs.formCustom.validateField('passwordCheck');
                  }
                  callback();
              }
          };
          const validatePassCheck = (rule, value, callback) => {
              if (value === '') {
                  callback(new Error(language.querenmima));
              } else if (value != this.formCustom.newPassword) {
                  callback(new Error(language.xinjiumimabuyiyang));
              } else {
                  callback();
              }
          };
      return {
        formCustom: {
            password:'',
            newPassword: '',
            passwordCheck: '',


        },
        languages:{},

        ruleCustom: {
            password: [
                { required: true,validator: validateOldPass, trigger: 'blur' }
            ],
            newPassword: [
                { required: true,validator: validatePass, trigger: 'blur' }
            ],
            passwordCheck: [
                { required: true,validator: validatePassCheck, trigger: 'blur' }
            ],
        }
      }
    },
    props:['userName'],
    // mounted: function () {


    // },
    filters: {
      delQuotes: function (value) {
        // var reg = /^[\'\"]+|[\'\"]+$/g;
        // value = value.replace(reg,"");
        return value;
      }
    },
    methods:{
      handleSubmit (name) {
          let that = this;
          that.$refs[name].validate((valid) => {
              if (valid) {
                let params = that.formCustom;
                let token = sessionStorage.getItem("token");
                axios.post(config.password,params,{
                  headers: {
                    'Accept': 'application/json,text/html,text/html',
                    'Content-Type': 'application/json',
                    'token': token
                  }, 
                  // transformRequest: [
                  //   function (data) {
                  //     return Qs.stringify(data);
                  //   }],
                }).then(function(resp){
                 if(resp.data.code === 0){
                    sessionStorage.removeItem("user")
                    sessionStorage.removeItem("token")
                    sessionStorage.removeItem("islogin")
                    that.$Modal.success({
                      // title: "提示",
                      content: language.mimaxiugaichenggong,
                      onOk: function () {
                        that.$router.push('/login');
                      }
                    })
                  }
                }).catch(function(error){
                })
          //       axios.post(config.password,that.formCustom)resp => {
          // console.log(resp)
          //         // var $this = this;
          //         if(resp.code === 0){
          //           sessionStorage.removeItem("user")
          //           sessionStorage.removeItem("token")
          //           sessionStorage.removeItem("islogin")
          //           that.$Modal.success({
          //             title: "提示",
          //             content: "密码修改成功，请重新登录！",
          //             onOk: function () {
          //               that.$router.replace({ path: '/Login' });
          //             }
          //           })
          //         }
          //       }, error => {

          //       })
              } else {
                  this.$Message.error('Fail!');
              }
          })
      },
    },
    mounted() {
      this.languages=language
    }
  }
</script>



// WEBPACK FOOTER //
// ChangePwd.vue?1ff6d754